import { useEffect, useState } from "react";
import "./App.css";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import Porfolio from "./components/portfolio/Porfolio";
// import Qualification from "./components/qualification/Qualification";
import Loading from "./components/loading/Loading";
import ScrollUp from "./components/scrollup/ScrollUp";
import SkillsUpdatedUi from "./components/skills/SkillsUpdatedUi";
import Resume from "./resume/Resume";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 4000);
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Header />
      <main className="main">
        <Home />
        {/* <About /> */}
        <SkillsUpdatedUi />
        {/* <Services /> */}
        {/* <Qualification /> */}
        <Resume />
        <Porfolio />
        {/* <Testimonials /> */}
        <Contact />
      </main>
      <Footer />
      <ScrollUp />
    </>
  );
}

export default App;
